/**
* @license Apache-2.0
*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //

import arrayfun from '@stdlib/assert-tools-array-function';
import isArray from '@stdlib/assert-is-array';


// MAIN //

/**
* Tests if a value is an array of arrays.
*
* @name isArrayArray
* @type {Function}
* @param {*} value - value to test
* @returns {boolean} boolean indicating whether a value is an array of arrays
*
* @example
* var bool = isArrayArray( [ [], [] ] );
* // returns true
*
* bool = isArrayArray( [ {}, {} ] );
* // returns false
*
* bool = isArrayArray( [] );
* // returns false
*/
var isArrayArray = arrayfun( isArray );


// EXPORTS //

export default isArrayArray;
